export default "__VITE_ASSET__dddde591__"